import RestAPIClient from "services/RestAPIClient";
import { ILoginRequest, IRegisterRequest } from "./typings";
import Cookies from "js-cookie";
import registerService from "../pages/Register/services/registerService";

class AuthService extends RestAPIClient {
  constructor() {
    super("auth", false);
  }

  login = async (req: ILoginRequest): Promise<string> => {
    return (await this.post("/login", req)).data.token;
  };

  checkTokenValid = (): boolean => {
    // return true
    try {
      const token = Cookies.get("customer_id");
      if (!token) return false;
      return true;
    } catch (e) {
      return false;
    }
  };

  setToken = (token: string) => {
    Cookies.set("TOKEN", token, { expires: 365 });
  };

  getToken = (): string => {
    return Cookies.getJSON("customer_id") || undefined;
  };

  getTokenFromSCCode = async (code: string) => {
    return (await this.get(`/access-code?code=${code}`)).data.token;
  };

  getAuthError = async (code: string) => {
    return (await this.get(`/errors?code=${code}`)).data.error_msg;
  };

  removeToken = () => {
    Cookies.remove("customer_id");
  };

  register = async (req: IRegisterRequest) => {
    return await this.post("/signup", req);
  };

  isEmailExist = registerService.isEmailExist;
}

export default new AuthService();
